import {
	Breakpoints,
	Layout,
	Text,
	TokenTextAppearance,
	TokenTextColor,
	Image,
	Container,
	ContainerPadding,
	ThemeProvider,
	CTA,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { ResponsiveText } from '../components/responsive-text';

const DrivingSectionLayout = styled(Layout)`
	padding: var(--size-dynamic0250) 0;
`;

const DrivingSection = styled(Container)`
	position: relative;
	width: 100%;
	min-height: 380px;
	border-radius: 16px;
	padding: var(--size-dynamic0250) var(--size-grid001);
	overflow: hidden;
	display: flex;
	align-items: center;

	background-image: url('https://assets.volkswagen.com/is/image/volkswagenag/driving_experience_background?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT03OTgmZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmZTM0OA==');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: rgba(0, 0, 0, 0.35);
		z-index: 0;
	}

	> * {
		position: relative;
		z-index: 1;
	}

	@media screen and (min-width: 960px) {
		min-height: 558px;
	}
`;
const DrivingContainer = styled(Container)`
	width: var(--size-grid018);

	@media screen and (min-width: 1260px) {
		width: var(--size-grid011);
	}
`;

const ImageContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: center;
	padding-right: 20px;

	img {
		width: 32.9px;
		height: auto;
	}

	@media screen and (min-width: 960px) {
		img {
			width: 64.7px;
			height: auto;
		}
	}
`;

const TitleRow = styled.div`
	display: flex;
	align-items: center;
`;

const Button = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-wrap: wrap;
`;

export const DrivingExperience = (): React.ReactElement => {
	return (
		<DrivingSectionLayout
			data-testid="driving_experience__layout"
			appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 2 },
					{ name: 'a', columns: 20 },
					{ name: '.', columns: 2 },
				],
			}}
			allowOverflowingContent
		>
			<DrivingSection data-testid="driving-experience__section">
				<DrivingContainer data-testid="driving-experience__container">
					<TitleRow>
						<ImageContainer data-testid="image__container">
							<Image src="https://assets.volkswagen.com/is/image/volkswagenag/vw_logo_white-1?Zml0PWNyb3AlMkMxJndpZD0xMzAmaGVpPTEzMCZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmNzI5Mg==" alt="Volkswagen" />
						</ImageContainer>

						<ResponsiveText
							appearance={{
								[Breakpoints.default]: TokenTextAppearance.headline300,
								[Breakpoints.b960]: TokenTextAppearance.headline600,
							}}
							color={TokenTextColor.inverted}
							bold
						>
							Driving Experience
						</ResponsiveText>
					</TitleRow>

					<Container padding={{ top: ContainerPadding.dynamic0130, bottom: ContainerPadding.dynamic0130 }}>
						<Container padding={{ bottom: ContainerPadding.dynamic0050 }}>
							<Text appearance={TokenTextAppearance.headline300} color={TokenTextColor.inverted} bold>
								Vive más experiencias con Driving Experience
							</Text>
						</Container>

						<ResponsiveText
							appearance={{
								[Breakpoints.default]: TokenTextAppearance.copy200,
								[Breakpoints.b1920]: TokenTextAppearance.bigcopy100,
							}}
							color={TokenTextColor.inverted}
						>
							Todo lo que quieres saber al volante, lo enseñamos en nuestras escuelas de conducción.
							<br />
							Échales un ojo para obtener más información.
						</ResponsiveText>
					</Container>

					<Button>
						<ThemeProvider theme={'inverted'}>
							<CTA tag="a" aria-label="Descubre más" href="https://drivingexperience.volkswagen.es/" target="_blank">
								Descubre más
							</CTA>
						</ThemeProvider>
					</Button>
				</DrivingContainer>
			</DrivingSection>
		</DrivingSectionLayout>
	);
};
